import { createContext } from "react";

type AppPrefContextType = {
  isOrderEntryOpenedFromMain: boolean | undefined;
  setIsOrderEntryOpenedFromMain: React.Dispatch<
    React.SetStateAction<boolean | undefined>
  >;
  isAppActive: boolean | undefined;
  setIsAppActive: React.Dispatch<React.SetStateAction<boolean | undefined>>;
};

const AppPrefContext = createContext<AppPrefContextType | undefined>(undefined);

export default AppPrefContext;
